<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Siglas">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="12">
                <div class="form-label-group">
                  <b-form-input id="id" placeholder="ID" v-model="form._id" disabled />
                  <label for="id">ID</label>
                </div>
              </b-col> -->
              
              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="origins"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="name" placeholder="Nome" v-model="form.name" />
                  <label for="name">Nome</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="text">Texto</label>
                  <b-form-textarea
                    id="text"
                    placeholder="Texto"
                    rows="5"
                    v-model="form.text"
                  />
                </div>
              </b-col>

              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" checked="true" v-model="form.active">
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button>
                <b-button
                  variant="danger"
                  class="mr-1"
                  @click="onBackPage"
                >
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
  BFormTextarea
} from "bootstrap-vue";
import acronymsService from "@/providers/acronymsService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import vSelect from "vue-select";
import AppConstants from '@/appConstants';

export default {
  props: {},
  data() {
    return {
      dataID: null,
      origins: [],
      form: {
        _id: "",
        name: "",
        text: "",
        active: true,
        origin: "",
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Nova Sigla');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.loadData();
  },
  watch: {
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Nova Sigla');
      }
    },
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_ACRONYMS);
    },
    onSubmit() {
      acronymsService
        .registerAcronyms(this.form, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getAcronymsDetail() {
      const params = new URLSearchParams();
      acronymsService
        .getAcronymsDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.name = res.name;
          this.form.text = res.text;
          this.form.origin = {id: res.origin._id, name: res.origin.name};
          this.form.active = res.active;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      dropdownService
        .getAllOrigin(new URLSearchParams())
        .then((res) => {
          this.origins = res;
          if (this.isUpdate) {
            this.getAcronymsDetail();
          }
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    BFormTextarea,
    vSelect
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>